import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { AssignPermissionModel } from '../../models/permission.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
import { SearchProfileModel } from '../../models/profile.model'

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Permissao'

  constructor(private httpClient: HttpClient) {}

  public listPermissionProfileId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall/${id}`,
    )
  }

  public listPagedPermissionProfileId(
    page: number,
    rows: number = 15,
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public permissionUserlogged(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/usuario/minhastelas`,
    )
  }

  public permissionUserId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/telas/usuario/${id}`,
    )
  }

  public listPagedPermissionProfile(
    page: number,
    rows: number = 15,
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/telas/perfil/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedPermissionProfile(
    page: number,
    rows: number = 15,
    model: SearchProfileModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/telas/perfil/search/?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public assignProfilePermission(
    model: AssignPermissionModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/add/perfil`,
      model,
    )
  }

  public unassignProfilePermission(
    model: AssignPermissionModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove/perfil`,
      model,
    )
  }
}
